import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import {
    lighten,
    ToggleButton,
    ToggleButtonGroup,
    useTheme
} from "@mui/material";
import { Controller, FieldPath } from "react-hook-form";
import { SearchFieldLabel } from "../components/label";

type PriceToggleProps = {
    name: FieldPath<SearchFormInputs>;
    label: string;
    className?: string;
};

const PriceToggleButton = ({ toggleValue, currentValue }) => {
    const theme = useTheme();
    const lightenedShRed = lighten(theme.palette.primary.main, 0.7);
    return (
        <ToggleButton
            value={toggleValue}
            className={`flex w-full gap-3`}
            sx={{
                padding: "6px"
            }}
        >
            {toggleValue >= currentValue ? (
                <CheckCircleIcon
                    fontSize="small"
                    color="primary"
                    className="pointer-events-none"
                    sx={{
                        color: toggleValue != currentValue && lightenedShRed
                    }}
                />
            ) : (
                <RadioButtonUncheckedIcon
                    fontSize="small"
                    className="pointer-events-none"
                />
            )}
            {toggleValue === 0 ? "$$$" : toggleValue === 1 ? "$$" : "$"}
        </ToggleButton>
    );
};

export const PriceToggle = ({ name, label }: PriceToggleProps) => {
    return (
        <Controller<SearchFormInputs>
            name={name}
            defaultValue={0}
            render={({ field: { onChange, value } }) => {
                return (
                    <div className="">
                        <SearchFieldLabel name={name}>{label}</SearchFieldLabel>
                        <ToggleButtonGroup
                            value={value}
                            exclusive
                            onChange={(_, newValue) => {
                                onChange(newValue);
                            }}
                            className="flex w-full"
                        >
                            <PriceToggleButton
                                toggleValue={2}
                                currentValue={value}
                            />
                            <PriceToggleButton
                                toggleValue={1}
                                currentValue={value}
                            />
                            <PriceToggleButton
                                toggleValue={0}
                                currentValue={value}
                            />
                        </ToggleButtonGroup>
                    </div>
                );
            }}
        />
    );
};
